var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.fields.length)?_c('i',{staticClass:"fas fa-exclamation-triangle text-danger missing-required-warning",attrs:{"title":_vm.tooltip,"aria-label":_vm.tooltip,"role":"img"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }